import { LOGOUT } from 'JS/actionCreators/authActions';

import {
  DOWNLOAD_RESET,
  DOWNLOAD_REQUEST,
  DOWNLOAD_REQUEST_FAILED,
  DOWNLOAD_REQUEST_SUCCESS,
  START_RENDER_STATUS_POLLING,
  STOP_RENDER_STATUS_POLLING,
  GET_VIDEO_DOWNLOAD_URL_SUCCESS,
  GET_VIDEO_DOWNLOAD_URL_FAILED,
  UPDATE_DOWNLOAD_COUNT,
  FETCH_RENDER_PROGRESS_SUCCESS,
  RENDER_FAILED
} from '../actionCreators/downloadActions';

const defaultState = {
  error: null,
  renderInProgress: false,
  downloadUrl: null,
  downloadingInProgress: false,
  freeDownloadCount: 0,
  formatRequested: null,
  segmentsRequested: 0,
  renderStatus: {
    max: 100,
    complete: 0,
    message: 'Requesting render'
  }
};

export default function downloadReducer(state = defaultState, action) {
  switch (action.type) {
    case DOWNLOAD_REQUEST_SUCCESS:
      return {
        ...state,
        error: null,
        downloadingInProgress: true,
        segmentsRequested: action.numSegments
      };

    case GET_VIDEO_DOWNLOAD_URL_FAILED:
    case DOWNLOAD_REQUEST_FAILED:
    case RENDER_FAILED:
      return {
        ...state,
        error: action.error,
        downloadUrl: null,
        downloadingInProgress: false
      };

    case DOWNLOAD_REQUEST:
      return {
        ...state,
        error: null,
        downloadingInProgress: true,
        formatRequested: action.format
      };

    case START_RENDER_STATUS_POLLING: {
      return {
        ...state,
        downloadingInProgress: true,
        renderInProgress: true
      };
    }

    case STOP_RENDER_STATUS_POLLING: {
      return {
        ...state,
        downloadingInProgress: true,
        renderInProgress: false
      };
    }

    case GET_VIDEO_DOWNLOAD_URL_SUCCESS: {
      return {
        ...state,
        downloadingInProgress: false,
        downloadUrl: action.downloadUrl
      };
    }

    case UPDATE_DOWNLOAD_COUNT: {
      return { ...state, freeDownloadCount: action.count };
    }

    case FETCH_RENDER_PROGRESS_SUCCESS: {
      const renderStatus = getRenderStatusState(state, action.result);
      return { ...state, renderStatus };
    }

    case DOWNLOAD_RESET:
      return { ...defaultState, freeDownloadCount: state.freeDownloadCount };

    case LOGOUT: {
      return defaultState;
    }

    default:
      return state;
  }
}

function getRenderStatusState(state, result) {
  const message = getRenderStatusMessage(result);
  const { max, complete } = getRenderStatusComplete(state, result);

  return {
    ...state.renderStatus,
    message,
    max,
    complete
  };
}

function getRenderStatusMessage(result) {
  const { videoRequestComplete, segmentCount, transcodeComplete, mergeComplete, segmentTotal } = result;

  if (mergeComplete) {
    return `Downloading project`;
  }

  if (transcodeComplete) {
    return `Merging ${segmentTotal} segments`;
  }

  if (segmentCount) {
    return `Rendering ${segmentTotal} segments`;
  }

  if (videoRequestComplete) {
    return 'Rendering';
  }

  return 'Requesting render';
}

function getRenderStatusComplete(state, result) {
  const { segmentsRequested } = state;
  const { videoRequestComplete, segmentCount, transcodeComplete, mergeComplete } = result;

  if (!segmentsRequested) {
    return {
      max: 100,
      complete: 0
    };
  }

  const nonValueSteps = [videoRequestComplete, transcodeComplete, mergeComplete];
  const totalSteps = nonValueSteps.length + segmentsRequested * 2;
  const completeNonValueSteps = nonValueSteps.filter(Boolean).length;
  const complete = segmentCount + completeNonValueSteps;

  return {
    max: totalSteps,
    complete: complete
  };
}
